
import { sample } from 'effector';

import { getAllCategoriesQuery } from '@/shared/api/catalog/api';
import { pagesPath } from '@/shared/config/$path';
import { declarePage } from '@/shared/lib/effector/page';

export const homePage = declarePage({
  pageType: pagesPath.$url().pathname,
});

sample({
  clock: homePage.open,
  target: getAllCategoriesQuery.refresh,
});
